import { Link } from 'react-router-dom';
import { JdsSearchInput } from '../../../components/jds/JdsSearchInput';
import { PlusIcon } from '../../../components/jds/icons';

export const Actions = ({ filterText, onFilter }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 'var(--space-8)',
      width: '100%',
    }}
  >
    <JdsSearchInput
      id="search"
      placeholder="Pesquisar"
      filterText={filterText}
      onFilter={onFilter}
    />
    <Link
      to="/payments/items/add"
      className="jds-btn jds-btn--filled jds-btn--brand"
      // a:hover (Bootstrap) pinta o texto de link por cima de .jds-btn--filled
      style={{ color: 'var(--fg-neutral-subtler)' }}
    >
      Novo produto
      <PlusIcon />
    </Link>
  </div>
);
